import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSVLink } from "react-csv";
import {
  Button
} from "shards-react";
import { faDownload, faFileCsv, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import XLSX from 'xlsx';
import { Modal, ModalBody, ModalHeader } from "shards-react";
import Select from "react-select";


const DownloadButton = ({
  filename = "",
  fileData = [],
  showPdfLoading = false,
  createPdf,
  className = ""
}) => {
  const [typeFile, setTypeFile] = useState('csv');

  const downloadOptions = [
    { value: 'csv', label: 'CSV', icon: faFileCsv },
    { value: 'xls', label: 'XLS', icon: faFileExcel },
    { value: 'pdf', label: 'PDF', icon: faFilePdf }
  ];

  const generateExcel = () => {
    if (fileData.length > 0) {
      let tempList = [];
      let headers = fileData[0];

      for (let x = 0; x < fileData.length; x++) {
        if (x > 0) {
          let tempData = {};
          for (let y = 0; y < fileData[x].length; y++) {
            const element = fileData[x][y];
            tempData[headers[y]] = element;
          }
          tempList.push(tempData)
        }
      }
  
      const ws = XLSX.utils.json_to_sheet(tempList);
      /* add to workbook */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Logs");
      /* generate an XLSX file */
      XLSX.writeFile(wb, filename+".xlsx");
    }
  }

  const handleDownload = () => {
    if (typeFile === "xls") {
      generateExcel();
    } else if (typeFile === "pdf") {
      createPdf();
    }
    // For CSV, the CSVLink component handles the download
  }

  const formatOptionLabel = ({ value, label, icon }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FontAwesomeIcon icon={icon} style={{ marginRight: '8px', color: '#21AA73' }} />
      <span>{label}</span>
    </div>
  );

  return (
    <>
      <div className={`d-flex align-items-center justify-content-end ${className}`} style={{height: '38px'}}>
        <div style={{ width: '70%', position: 'relative', marginRight: '10px' }}>
          <Select
            value={downloadOptions.find(option => option.value === typeFile)}
            onChange={(option) => setTypeFile(option.value)}
            options={downloadOptions}
            formatOptionLabel={formatOptionLabel}
            isSearchable={false}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : '#dfe3e9',
                boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : null,
                minHeight: '38px',
                '&:hover': {
                  borderColor: 'rgba(33, 170, 115, 0.4)'
                }
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected 
                  ? 'rgba(33, 170, 115, 0.1)' 
                  : state.isFocused 
                    ? 'rgba(33, 170, 115, 0.05)' 
                    : null,
                color: state.isSelected ? '#21AA73' : base.color
              }),
              menuList: (base) => ({
                ...base,
                padding: '5px'
              }),
              menu: (base) => ({
                ...base,
                boxShadow: '0 3px 12px rgba(0,0,0,0.08)',
                borderRadius: '6px',
                border: '1px solid #eaedf3',
                backgroundColor: '#fff'
              }),
              indicatorSeparator: () => ({
                display: 'none'
              }),
              dropdownIndicator: (base, state) => ({
                ...base,
                color: state.isFocused ? '#21AA73' : '#818ea3',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: '#21AA73'
                }
              }),
              singleValue: (base) => ({
                ...base,
                color: '#495057'
              })
            }}
          />
        </div>

        <div style={{ width: '30%', minWidth: '40px' }}>
          {typeFile === "csv" ? (
            <CSVLink data={fileData} filename={filename+".csv"} className="btn btn-primary btn-sm" style={{
              backgroundColor: '#21AA73',
              borderColor: '#21AA73',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '38px',
              height: '38px',
              padding: 0,
              borderRadius: '4px'
            }}>
              <FontAwesomeIcon icon={faDownload} />
            </CSVLink>
          ) : (
            <Button theme="primary" size="sm" onClick={handleDownload} style={{
              backgroundColor: '#21AA73',
              borderColor: '#21AA73',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '38px',
              height: '38px',
              padding: 0,
              borderRadius: '4px'
            }}>
              <FontAwesomeIcon icon={faDownload} />
            </Button>
          )}
        </div>
      </div>
      
      <Modal open={showPdfLoading}>
        <ModalHeader>Creating PDF</ModalHeader>
        <ModalBody>Please wait while your PDF is being generated...</ModalBody>
      </Modal>
    </>
  )
};

DownloadButton.propTypes = {
};

export default DownloadButton;
